import * as Yup from 'yup'
import { Form, Col } from 'react-bootstrap'
import { CustomFormControl, Textarea } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    otherInformation: checkText(settings),
});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Form.Group as={Col} controlId="formOtherInformation">
                <CustomFormControl
                    as={Textarea}
                    //rows={3}
                    colors={colors}
                    placeholder="Sonstiges"
                    type="text"
                    name="otherInformation"
                    value={values.otherInformation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.otherInformation && !errors.otherInformation}
                    isInvalid={errors.otherInformation}
                    maxLength={2000}
                />
                <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                    {errors.otherInformation}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};